import axios from "axios";
import { useEffect, useState } from "react";
import { appUrl } from "../../../../../../utils/config";
import { debounce } from "lodash";
// Import the action to save inventory reconciliation filters
import { fetchInventoryReconciliationFilters, saveInventoryReconciliationFilters } from "../../../../containers/actions/common/inventoryStatusActions";
const useFilter = (setFilterDialog) => {
    const initialFilterState = {
      timeStamp: "All",
      onHandQuantityDifference: "All",
      quantityCommittedDifference: "All",
      reasonForDifference: "All",
  };

  const [filter, setFilter] = useState(initialFilterState);
  //   console.log("🚀 ~ useFilter ~ filter:", filter);
  const [filterLoading, setFilterLoading] = useState(false);
  const [filterError, setFilterError] = useState(null);

  useEffect(() => {
    fetchFilters();
  }, []);
  const fetchFilters = async () => {
    setFilterLoading(true);
    try {
      // Use the unified API to fetch filters
      const result = await fetchInventoryReconciliationFilters()();
      
      if (result.status && result.save_filter_options) {
        // Set the filters from the response
        setFilter(result.save_filter_options);
      } else {
        console.warn("No reconciliation filter options found in the response.");
      }
    } catch (err) {
      console.error("Error fetching filters:", err);
    } finally {
      setFilterLoading(false);
    }
  };
  const saveFilters = async () => {
    setFilterLoading(true);
    try {
   
      
      // Use the unified API to save filters
      const result = await saveInventoryReconciliationFilters(filter)();
      
      if (result.status) {
        setFilterDialog("success");
        // Refresh filters after saving
        fetchFilters();
      } else {
        setFilterDialog("error");
      }
    } catch (err) {
      console.error("Error saving filters:", err);
      setFilterDialog("error");
    } finally {
      setFilterLoading(false);
    }
  };

  const handleChange = debounce((e) => {
    setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }, 300);

  // const clearFilters = () => {
  //   setFilter(initialFilterState);
  //   setFilterLoading(true);
  //   // const uri = `${appUrl}/user/saveReconciliationInventoryFilters`;
  //   axios
  //     .post(`${appUrl}/user/saveReconciliationInventoryFilters`, filter)
  //     .then((res) => {
  //       // throw new Error("Something went wrong");
  //       if (res.data.status) {
  //         setFilterDialog("success");
  //       } else {
  //         setFilterDialog("error");
  //       }
  //     })
  //     .catch((err) => {
  //       // setFilterError(err.message || "Something went wrong");
  //       setFilterDialog("error");
  //     })
  //     .finally(() => {
  //       setFilterLoading(false);
  //     });
  // };

const clearFilters = async () => {
  const initialFilterState = {
    inventoryReconciliationDashboard: {
      timeStamp: "All",
      onHandQuantityDifference: "All",
      quantityCommittedDifference: "All",
      reasonForDifference: "All",
    },
  };

  setFilter(initialFilterState);
  setFilterLoading(true);

  try {
    // ✅ Wait for save API to complete
    const res = await axios.post(`${appUrl}/user/saveFilters`, initialFilterState);

    if (res.data.status) {
      setFilterDialog("success");

      // ✅ Only fetch after save succeeds
      const result = await fetchInventoryReconciliationFilters()();

      if (result.status && result.save_filter_options) {
        setFilter(result.save_filter_options);
      } else {
        console.warn("No reconciliation filter options found in the response.");
      }
    } else {
      setFilterDialog("error");
    }
  } catch (err) {
    console.error("Error saving filters:", err);
    setFilterDialog("error");
  } finally {
    setFilterLoading(false);
  }
};

  return {
    filter,
    setFilter,
    handleChange,
    clearFilters,
    // filterError,
    saveFilters,
    // setFilterLoading,
    // setFilterDialog,
    // initialFilterState,
    setFilter,

  };
};

export default useFilter;
